import React from "react";
import { Icon } from "@iconify/react";

function FooterComp() {
  return (
    <>
      <footer className="footer">
        <div className="footer_bg">
          <div className="footer_container container grid">
            <div>
              <h1 className="footer_title">Ankit Mittal</h1>
              <span className="footer_subtitle">Software Developer</span>
            </div>

            <ul className="footer_links">
              <li>
                <a href="#about" className="footer_link">
                  About
                </a>
              </li>
              <li>
                <a href="#projects" className="footer_link">
                  Projects
                </a>
              </li>
              <li>
                <a href="#contact" className="footer_link">
                  Contact Me
                </a>
              </li>
            </ul>

            <div className="footer_socials">
              <a
                href="https://www.linkedin.com/in/ankitmittal2404/"
                target="_blank"
                className="footer_social"
                rel="noreferrer"
              >
                <i className="uil uil-linkedin-alt"></i>
              </a>
              <a
                href="https://github.com/ankit2404"
                target="_blank"
                className="footer_social"
                rel="noreferrer"
              >
                <i className="uil uil-github-alt"></i>
              </a>
              <a
                href="mailto:mittalankit2404@gmail.com"
                target="_blank"
                className="footer_social"
                rel="noreferrer"
              >
                <Icon icon="ci:mail" inline={true} />
              </a>
            </div>
          </div>

          <p className="footer_copy">
            &#169; Ankit Mittal. All rights reserved
          </p>
        </div>
      </footer>
    </>
  );
}

export default FooterComp;
